var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsScrollV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.8209 6.24661L12.4293 10.3256C12.1922 10.6108 11.8078 10.6108 11.5707 10.3256L8.17906 6.24661C7.79655 5.78658 8.06746 5 8.6084 5H15.3916C15.9325 5 16.2034 5.78658 15.8209 6.24661ZM15.8209 17.7534C16.2034 18.2134 15.9325 19 15.3916 19H8.6084C8.06746 19 7.79655 18.2134 8.17906 17.7534L11.5707 13.6744C11.8078 13.3892 12.1922 13.3892 12.4293 13.6744L15.8209 17.7534Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsScrollV);
export default __webpack_public_path__ + "static/media/arrows-scroll-v.c4edd91c823ed714974f442f500bfb6c.svg";
export { ForwardRef as ReactComponent };